<template>
  <div :class="isLogged ? 'w-full mt-14 mb-20' : 'mt-20 mb-20 w-3/4 mx-auto ml-8'">
    <div class="my-5 pb-3 text-lg lg:text-2xl w-ful">
      <h1 class="uppercase flex justify-start">
        {{ isLogged ? "The Masterclasses you subscribed" : "Subscribed Masterclass"}}
      </h1>
    </div>
    <div v-if="masterclasses.length>0">
    <masterclass-card class="hidden md:block w-2/3"
      v-for="masterclass in masterclasses"
      :key="masterclass.id"
      :masterclass="masterclass" />
      <masterclass-card-mobile class="block md:hidden"
      v-for="masterclass in masterclasses"
      :key="masterclass.id"
      :masterclass="masterclass" />
    </div>
    <div v-else>
      <div v-if="isLogged">
       {{$t('masterclass.no-masterclass')}} <br>
        {{$t('masterclass.started')}}
        <router-link to="/masterclasses" class="font-bold border-b border-chocolate-academy-600
        hover:text-beige-academy-400">
          E-cademy masterclass!
        </router-link>
      </div>
      <div v-else>
        {{$t('masterclass.no-masterclass')}}
      </div>
    </div>
  </div>
</template>

<script>
import { getStudentMasterclasses } from '@/services/StudentService';
import { mapGetters } from 'vuex';
import MasterclassCard from '../masterclasses/MasterclassCard.vue';
import MasterclassCardMobile from '../masterclasses/MasterclassCardMobile.vue';

export default {
  components: { MasterclassCard, MasterclassCardMobile },

  data() {
    return {
      masterclasses: [],
      isLogged: !this.$route.params.slug,
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  created() {
    this.getMasterclasses();
  },

  methods: {
    getMasterclasses() {
      getStudentMasterclasses(this.isLogged ? this.user.slug : this.$route.params.slug)
        .then(({ data }) => {
          this.masterclasses = data;
        });
    },
  },
};
</script>
